import { actionCreatorsFactory } from '../actions';
import { ListType } from '../constants';
import { codeApiGateway } from './api';
import { CodeDescriptionMetadata, CodeDescriptionSearchData, CodeDescriptionSearchModel, ModifiedCodeDescription } from './types-store';

export const actionCreators = actionCreatorsFactory<
  CodeDescriptionMetadata, CodeDescriptionSearchData, ModifiedCodeDescription, CodeDescriptionSearchModel
>(
  ListType.code,
  codeApiGateway
);
